import React from 'react';
import {createNewSearch, getAllFilters} from './actions/searchesList';
import {togglePageClass} from '../../_shared/GWTBridge/invoke/headerPanel';
import {createRoot} from 'react-dom/client';
import {SearchesGenerator} from './SearchesGenerator';

let generatorRef;
let root;

type Props = {
    isAISearch?: boolean;
};

function _renderGenerator(selector: string, props: Props = {}) {
    const {isAISearch} = props;

    generatorRef?.current && generatorRef?.current.open(isAISearch);
    togglePageClass(true);

    if (!root) root = createRoot(document.getElementById(selector));

    root.render(
        <SearchesGenerator
            {...props}
            ref={ref => {
                generatorRef = ref;
                generatorRef && generatorRef.open(isAISearch);
            }}
        />
    );
}

export function renderGenerator(selector: string, props: any = {}) {
    getAllFilters(props.item)
        .then(() => _renderGenerator(selector, props))
        .catch(err => console.log(err));
}

export function renderGeneratorNewState(params: Props = {}) {
    getAllFilters()
        .then(() => {
            createNewSearch();
            _renderGenerator('searchesGenerator', params);
        })
        .catch(err => console.log(err));
}
